export default __webpack_public_path__ + "e20be5733507afd04c351d95c8f28dc4.png";